export const colors = {
  sky_blue: {
    DEFAULT: "#8ecae6",
    100: "#0d2e3d",
    200: "#1b5c7a",
    300: "#288ab7",
    400: "#51aed9",
    500: "#8ecae6",
    600: "#a5d5eb",
    700: "#bbdff0",
    800: "#d2eaf5",
    900: "#e8f4fa",
  },
  blue_green: {
    DEFAULT: "#0d948a",
    100: "#001f1d",
    200: "#003e3a",
    300: "#005d58",
    400: "#007c76",
    500: "#0d948a",
    600: "#30bcb3",
    700: "#5dd6d2",
    800: "#91f9f7",
    900: "#d7fafa",
  },
  prussian_blue: {
    DEFAULT: "#0891b1",
    100: "#013743",
    200: "#024756",
    300: "#055b6e",
    400: "#077992",
    500: "#0891b1",
    600: "#1ba2c0",
    700: "#3fbedb",
    800: "#98e4f6",
    900: "#d0eef5",
  },
  caribbean_current: {
    DEFAULT: "#15616d",
    100: "#041315",
    200: "#08262b",
    300: "#0c3940",
    400: "#104c56",
    500: "#15616d",
    600: "#2199ab",
    700: "#3ec5da",
    800: "#7ed9e7",
    900: "#bfecf3",
  },
  ut_orange: {
    DEFAULT: "#fb8500",
    100: "#321b00",
    200: "#643500",
    300: "#965000",
    400: "#c86b00",
    500: "#fb8500",
    600: "#ff9e2f",
    700: "#ffb663",
    800: "#ffce97",
    900: "#ffe7cb",
  },
  sienna: {
    DEFAULT: "#78290f",
    100: "#180803",
    200: "#2f1006",
    300: "#471809",
    400: "#5e200c",
    500: "#d2341b",
    600: "#f0815c",
    700: "#f5a78d",
    800: "#f5c9ba",
    900: "#fbddd3",
  },
  white: {
    DEFAULT: "#ffffff",
  },
  black: {
    DEFAULT: "#000000",
  },
};

export default colors;
